import React, {FunctionComponent} from "react";
import {FooterColumnData} from "../../interfaces/footer.interface";
import {KlearLogo} from "../klearLogo/klearLogo.component";
import {BackgroundShape} from "../backgroundShape/backgroundShape.component";
import {BackgroundShapeProps} from "../../interfaces/strapi";

const styles = require('./footer.component.scss');

export interface FooterProps {
    columns: FooterColumnData[];
    backgroundShapes: BackgroundShapeProps[];
}

export const Footer: FunctionComponent<FooterProps> = props => {
    const {columns, backgroundShapes} = props;

    return (
        <>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.7.2/css/all.css"
                  integrity="sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr"
                  crossOrigin="anonymous"/>
            <div className="clear"/>
            <footer className={styles.footerBox}>
                {backgroundShapes &&
                    backgroundShapes.map((shape, index) => {
                        return <BackgroundShape key={index} {...shape} bottom />;
                    })
                }
                <div className={styles.footer}>
                    <div className={styles.logoAndContactContainer}>
                        <KlearLogo size={'large'} color={'white'}/>
                    </div>
                    <div className={styles.columnsContainer}>
                        {columns.map((columnData) =>
                            <div key={columnData.title} className={styles.singleColumnContainer}>
                                <div className={styles.title}>
                                    {columnData.title}
                                </div>
                                {columnData.links.map((link, index) =>
                                    <a key={index} className={styles.link} href={link.url}>
                                        {link.text}
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </footer>
        </>
    );
};
